import React, { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', error = false, disabled, ...props }, ref) => {
    return (
      <input
        ref={ref}
        disabled={disabled}
        className={`w-full px-4 py-3 rounded-2xl border-2 bg-white text-brand-text-dark text-sm font-medium placeholder-brand-text-muted/50 focus:outline-none transition-all duration-150
          ${
            error
              ? 'border-brand-error focus:border-brand-error focus:ring-brand-error'
              : 'border-brand-border focus:border-brand-primary focus:ring-brand-primary'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed bg-brand-bg' : ''}
          ${className}`}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;
